import React, { useEffect, useState } from "react";
import CanvasJSReact from "@canvasjs/react-charts";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import { Col, Button } from "react-bootstrap";
import { formatDate } from "../../utils/helper";

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const LineChart = ({ dateRange }) => {
  const [optionLead, setOptionLead] = useState([]);
  const [selectedLead, setSelectedLead] = useState(null);
  const [projectsData, setProjectsData] = useState([]);

  useEffect(() => {
    fetchInitialData(dateRange);
  }, [dateRange]);
  async function fetchInitialData() {
    try {
      const filterDate = {};
      if (Array.isArray(dateRange)) {
        const [fromDate, toDate] = dateRange;
        if (fromDate && toDate) {
          filterDate.fromDate = formatDate(fromDate);
          filterDate.toDate = formatDate(toDate);
        }
      }
      // Fetch leads data and set options
      const fetchLeads = await fuziElevatorsApi.fetchLeads();
      if (fetchLeads && Array.isArray(fetchLeads)) {
        const leadOptions = fetchLeads.map((item) => ({
          value: item.id,
          label: item.lead_name,
        }));
        setOptionLead(leadOptions);
      }
      const fetchProjects = await fuziElevatorsApi.fetchOrderForDashboard(
        Object.keys(filterDate).length > 0 ? filterDate : null
      );
      if (fetchProjects && Array.isArray(fetchProjects)) {
        setProjectsData(fetchProjects);
      } else {
        setProjectsData([]);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      setProjectsData([]);
    }
  }
  console.log("FETCH_ON_LOAD_PROJECTS", projectsData);

  useEffect(() => {
    async function fetchProjectsByLeadId(leadId) {
      try {
        if (leadId) {
          const fetchProject = await fuziElevatorsApi.fetchOrdersByLeadId(
            leadId
          );
          if (fetchProject && Array.isArray(fetchProject)) {
            setProjectsData(fetchProject);
          } else {
            setProjectsData([]);
          }
        } else {
          // Handle default state (when no lead is selected)
          const fetchProjects = await fuziElevatorsApi.fetchOrderForDashboard();
          if (fetchProjects && Array.isArray(fetchProjects)) {
            setProjectsData(fetchProjects);
          } else {
            setProjectsData([]);
          }
        }
      } catch (error) {
        console.error("Error fetching projects by lead ID:", error);
        setProjectsData([]);
      }
    }

    fetchProjectsByLeadId(selectedLead?.value);
  }, [selectedLead]);

  //This is Using for Options For chart showing (Added by Farhan Khan on 13-June-2024)
  const options = {
    animationEnabled: true,
    axisY: {
      title: "Order Booking Total Amount",
      scaleBreaks: {
        autoCalculate: true,
        type: "wavy",
        lineColor: "black",
      },
    },
    data: projectsData
      ? [
        {
          type: "column",
          indexLabel: "{y}",
          indexLabelFontColor: "black",
          toolTipContent: `<strong>{label}</strong><br/>
                       Total Amount: {order_amount}<br/>
                       Pending Amount: {order_pending_amount}<br/>
                       Received Amount: {order_amount_received}`,
          dataPoints: projectsData.map((project) => ({
            label: project.offer_name_label,
            y: parseFloat(project.order_amount) || 0,
            order_amount: project.order_amount || 0,
            order_pending_amount: project.pendingamount || 0,
            order_amount_received: project.paidamount || 0,
          })),
        },
      ]
      : [],
  };

  const handleLead = (selectedOption) => {
    setSelectedLead(selectedOption);
  };

  const handleClear = () => {
    setSelectedLead(null);
    setProjectsData([]);
    fetchInitialData();
  };

  console.log("Order LineChart", projectsData);

  return (
    <div>
      <Col lg={4} className="mt-4">
        <Form.Group>
          <div className="d-flex flex-column">
            <div className="d-flex">
              <Select
                required
                placeholder="Select Lead Name..."
                classNamePrefix="react-select"
                onChange={handleLead}
                options={optionLead}
                value={selectedLead}
              />
              <Button
                variant="secondary"
                onClick={handleClear}
                className="ms-2"
              >
                Clear
              </Button>
            </div>
            {/* {selectedLead && projectsData.length === 0 && (
              <div className='mt-2 text-center text-danger'>
                No Record Found
              </div>
            )} */}
          </div>
        </Form.Group>
      </Col>
      <div className="mt-4">
        {projectsData.length > 0 ? (
          <CanvasJSChart options={options} />
        ) : (
          selectedLead && (
            <div className="text-center text-danger">No Record Found</div>
          )
        )}
      </div>
    </div>
  );
};

export default LineChart;
